<template>
  <div>
    <div
      v-if="page == 'forgot'"
      class="w-full flex bg-white my-2 justify-center px-6 py-10 height-100 rounded-10px"
    >
      <div class="flex justify-center w-28per items-center">
        <div class="elshadow px-6 w-full py-10 rounded-2xl">
          <div class="text-center">
            <h1 class="fsize22 text-dark font-semibold">Forgot password</h1>
            <p class="fsize14 text-gray justify-center pt-2 flex">
              Check your inbox to access this credentials
            </p>
          </div>
          <div class="mt-6">
            <div class="mt-4">
              <div class="relative">
                <small class="fsize12 bg-white text-dark font-medium"
                  >Email</small
                >
                <el-input
                  placeholder="Your Email"
                  v-model="email"
                  class="rounded-xl mt-2"
                />
              </div>
            </div>

            <div class="mt-4">
              <vs-button
                variant="primary"
                @click="OtpSending('otppage')"
                class="rounded-full bg-primary border-0 text-white font-normal lg:py-3 fsize14 md:py-3 py-2 w-full sm-fsize14"
              >
                Proceed
              </vs-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Otp
      v-if="page == 'otp'"
      @data="Gotp"
      @pages="changepages"
      :Email="email"
    ></Otp>
    <CreatePassword
      v-if="page.props == 'create'"
      :Email="email"
    ></CreatePassword>
  </div>
</template>
<script>
import OTp from "./Otp.vue";
import CreatePassword from "./Password.vue";
export default {
  data() {
    return {
      email: "",
      page: "forgot",
      fotp: "",
    };
  },
  components: {
    Otp: OTp,
    CreatePassword: CreatePassword,
  },

  methods: {
    compareOTP() {
      payload = {
        email: this.email,
        otp: this.fotp,
      };
      const data = this.$store.dispatch("admin/confirmOTP", payload);
      console.log(data);
    },
    OtpSending() {
      if (this.email) {
        this.$store.dispatch("admin/sendOTP", { email: this.email });
        this.page = "otp";
      } else {
        this.$swal("plz put valid email");
      }
    },
    Gotp(data) {
      this.fotp = data.props;
    },
    changepages(data) {
      this.page = data;
    },
  },
  computed: {},
};
</script>

<style>
.col-ffc1 {
  color: #ffc148 !important;
}
.col-56 {
  color: #f6f6f6 !important;
}
.col-4f {
  color: #4f4f4f !important;
}
.bg-f9 {
  background: #f9f9f9 !important;
}
.third-fonts {
  line-height: 19px;
  font-size: 17px !important;
  color: #000 !important;
}
.second-fonts {
  line-height: 19px;
  font-size: 17px !important;
}
.bordb {
  border-bottom: 1px solid #ececec;
}
.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background: rgb(205, 49, 151) !important;
  color: #fff !important;
  border-radius: 4px !important;
  border: none !important;
}
.el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: none !important;
}
.bg-light-green {
  background: rgba(111, 205, 87, 0.16) !important;
  color: #6fcd57 !important;
}
.greenh {
  background: #6fcd57 !important;
  width: 3px !important;
  height: 3px !important;
  border-radius: 50% !important;
}
.bg-light-orange {
  background: rgba(255, 143, 11, 0.13) !important;
  color: #ff8f0b !important;
}
.cust-chips {
  font-size: 10px;
  color: grey;
  font-weight: 500;
  background: #f4f5f6;
  padding: 6px 10px;
  border-radius: 18px;
}
.chips-active {
  background-color: rgba(40, 199, 111, 0.12) !important;
  color: #2dce89 !important;
  font-weight: 600;
}
.w-28per {
  width: 28%;
}
</style>
